<template>
  <div
    class="workFlow"
    style="
      width: 260px;
      flex-shrink: 0;
      flex-grow: 0;
      border-left: 1px solid #ccc;
    "
  >
    <div
      style="
        font-size: 20px;
        font-weight: 600;
        margin-bottom: 20px;
        margin-left: 10px;
        padding-top: 10px;
      "
    >
      审批流程
    </div>
    <div>
      <div class="flowItem" v-for="(item, index) in list">
        <div class="left">
          <div class="icon">
            {{ item.auditName }}
          </div>
          <li
            style="
              position: absolute;
              right: 0px;
              top: 28px;
              font-size: 18px;
              background-color: white;
              border-radius: 50%;
            "
            :class="{
              'success el-icon-success': item.auditStatus === 1,
              'error el-icon-warning': item.auditStatus === 2,
            }"
          ></li>
          <div v-if="index != list.length - 1" class="line"></div>
        </div>
        <div class="right">
          <div class="top">
            <div class="info">{{ item.stepName }}</div>
            <div class="time">{{ item.auditTime | filterTime }}</div>
          </div>
          <div class="middle" v-if="item.auditStatus === 0">
            待 &nbsp;
            <div
              v-if="userInfo.employeeId === item.auditId"
              class="name"
              style="color: #409eff"
            >
              我
            </div>
            <div v-else class="name" style="color: #409eff">
              {{ item.auditName }}
            </div>
            审批
          </div>
          <div class="middle" v-else>
            <div v-if="userInfo.employeeId === item.auditId" class="name">
              我
            </div>
            <div v-else class="name">
              {{ item.auditName }}
            </div>
            <div
              class="status"
              :class="{
                success: item.auditStatus === 1,
                error: item.auditStatus === 2,
              }"
            >
              {{ item.auditStatus | filterStatus }}
            </div>
          </div>
          <div
            class="bottom"
            v-if="item.auditDescription && item.auditDescription.length > 0"
          >
            {{ item.auditDescription }}
          </div>
          <div style="height: 20px"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import commonUtil from "@/utils/commonUtil";
export default {
  computed: {
    ...mapGetters(["userInfo"]),
  },
  props: {
    list: [],
  },
  filters: {
    filterStatus(val) {
      if (val === 0) {
        return "待审核";
      } else if (val === 1) {
        return "审核通过";
      } else if (val === 2) {
        return "审核驳回";
      } else {
        return val;
      }
    },
    filterTime(val) {
      if (val == null) {
        return "";
      }
      let date = new Date(val);
      return commonUtil.parseTime(date, "MM-dd HH:mm");
    },
  },
};
</script>

<style lang="scss" scoped>
.workFlow {
  .flowItem {
    display: flex;
    flex-direction: row;
    .left {
      width: 50px;
      padding-left: 10px;
      display: flex;
      flex-direction: column;
      align-items: center;
      position: relative;
      .icon {
        width: 40px;
        height: 40px;
        border-radius: 50%;
        background-color: #66b1ff;
        line-height: 40px;
        color: white;
        text-align: center;
        overflow: hidden;
      }
      .line {
        width: 1px;
        height: 100%;
        flex: 1;
        background-color: #66b1ff;
      }
    }
    .right {
      flex: 1;
      margin-left: 10px;
      display: flex;
      flex-direction: column;
      .top {
        display: flex;
        flex-direction: row;
        align-items: center;
        .info {
          flex: 1;
        }
        .time {
          width: 80px;
          font-size: 12px;
          color: #666;
        }
      }
      .middle {
        display: flex;
        flex-direction: row;
        margin-top: 6px;
        .name {
          margin-right: 6px;
        }
        .status {
        }
      }
      .bottom {
        margin-top: 6px;
        background-color: #eee;
        padding: 6px;
        margin-right: 6px;
        font-size: 12px;
      }
    }
  }

  .success {
    color: #67c23a;
  }
  .error {
    color: #f56c6c;
  }
}
</style>
